export default {
  error: state => state.error,
  success: state => state.success,
  loading: state => state.loading,
  links: state => state.links,
  link: state => state.link,
  exportLoading: state => state.exportLoading,
  exportSuccess: state => state.exportSuccess,
  downloadLink: state => state.downloadLink,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Links/getters.js